// routes/generator.chat-editing.workspace.$workspaceId.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/generator.chat-editing.workspace.$workspaceId')

export const handle = {
  name: 'generator/chat-editing/workspace/:workspaceId',
  track: { scene: 'chat-editing', section: 'panel' },
}

export default dynamic(getClientModule, { ssr: false })
